export enum DynamicObjectType {
    Text,
    Folder,
    Number,
    Date,
    Lookup,
    // LookupArray,
    BusinessOwner,
    Boolean,
    Unknown,
    LegalCounsel,
}
